import DateFormatter from '../../../../helpers/DateFormatter';
import { GET_ACTIVATION_KEYS_DEFAULT_QUERY_PARAMS } from '../../../../constants/activationKeys';

const SUCCESSFUL = 'successful';
const PENDING = 'pending';

// A machine's card links here with the key in the URL (ResultItemCard).
export const ACTIVATION_KEY_URL_PARAM = 'activationKey';

export const successfulActivations = (activationKey) => {
	return (activationKey.activationHistories ?? []).filter((activation) => { return activation.status === SUCCESSFUL; });
};

/*
 * One table row per item of GET /v1/licensing/activation-keys (SYN-3449). Only the successful
 * activations count: they give N in "N of M Activation(s)" and fill the history dialog, and a key
 * none of them belongs to yet is pending.
 */
export const toActivationCodeRows = (activationKeys = []) => {
	return activationKeys.map((activationKey) => {
		const activations = successfulActivations(activationKey);

		return {
			id: activationKey.id,
			productKey: activationKey.productKey,
			createdAt: DateFormatter.formatDateToSpecificFormat(activationKey, 'createdAt', 'DD/MM/YYYY hh:mm:ss a'),
			status: activations.length ? SUCCESSFUL : PENDING,
			activations,
			extraActivations: activationKey.extraActivations ?? [],
			totalActivations: activationKey.totalActivations ?? 0
		};
	});
};

const trimmed = (text) => {
	return (text ?? '').trim();
};

/*
 * The query a key opens the page with: its first page, since a whole key has at most one row.
 */
export const queryForKey = (productKey) => {
	return { ...GET_ACTIVATION_KEYS_DEFAULT_QUERY_PARAMS, productKey: trimmed(productKey) };
};

/*
 * Both return the current query untouched when nothing changed, so a React state set with the
 * result bails out and no request is sent: the table reports the search it was opened with as a
 * search, and a pager click can repeat the page.
 */
export const queryForSearch = (current, searchText) => {
	const productKey = trimmed(searchText);

	if (productKey === current.productKey) {
		return current;
	}

	return { ...current, page: 1, productKey };
};

export const queryForPage = (current, page, pageSize) => {
	if (page === current.page && pageSize === current.pageSize) {
		return current;
	}

	return { ...current, page, pageSize };
};
